import { Task, ExpectedTaskAnswerMetadata } from "@jelly/lesson";

const items = [
  { id: "aa0600c2-4838-4f3b-8876-cba88a53b0b3", content: "The first bark band", options: {} },
  { id: "e1b66ee2-d33d-47ee-af7a-3d80fd9f1780", content: "The last bark band", options: {} },
  { id: "1843686f-4042-4d1a-8129-c03dc1248847", content: "The center band", options: {} },
  { id: "4ce3d13a-2923-4874-8144-772c48481ced", content: "They are all equal", options: {} },
];

export const task: Task = {
  id: "afe6d926-a69c-413b-b2f6-cf8451dfbdd0",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["e1b66ee2-d33d-47ee-af7a-3d80fd9f1780"],
};
